import endpoint from "../../config/endpoints";

export const CompOffJson = {
    showSaveNextBtn: true,
    formPath: "/holiday-structure-form",
    apiBaseURL: endpoint.compOff,
    changeExcel: endpoint.exportData,
    screenTitle: "Comp Off Process",
    screenTitleForProcess: "Comp Off Process",
    showAddButton: true,
    showPdfDownload: true,
    pdfFileName: "Holiday Structure",
    showExcelDownload: true,
    excelFileName: "Holiday Structure",
    formPathView: "/comp-off-view",
    isActiveURL: endpoint.holidayStructureHeader + "/update-is-active",
    openFormPathStatus: "/comp-off-process",


    tableColumnsToFilter: [
        {
            columnDisplayName: "Emp Code",
            columnKeyName: "empCode",
            isChecked: true,
        },
        {
            columnDisplayName: "Sales Team Name",
            columnKeyName: "salesTeamName",
            isChecked: true,
        },
        {
            columnDisplayName: "Sales Team Type",
            columnKeyName: "salesTeamType",
            isChecked: true,
        },
        {
            columnDisplayName: "Reporting Type",
            columnKeyName: "reportingManagerType",
            isChecked: true,
        },
        {
            columnDisplayName: "Reporting Name",
            columnKeyName: "reportingManagerName",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "From Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "fromDate",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "toDate-le",
        },
        {
            label: "To Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "toDate",
            onSubmit: "compare",
            onSubmitParameter: "fromDate-ge",
            isMandatory: true,
        },
    ],
};
